module.exports = __webpack_public_path__ + "static/4-7a7c144777f6120822558abadbe5e90d.png";